import { render, staticRenderFns } from "./AddressListModal.vue?vue&type=template&id=bfe19bfe&scoped=true"
import script from "./AddressListModal.vue?vue&type=script&lang=js"
export * from "./AddressListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe19bfe",
  null
  
)

export default component.exports